(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cf-mini-product-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cf-mini-product-carousel')) {
    class CFMiniProductCarousel extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return
        this.dataset.initialized = 'true'
        this.viewport = this.querySelector('[data-viewport]')
        this.track = this.querySelector('[data-track]')
        this.items = Array.from(this.querySelectorAll('[data-cfmp-item]'))
        this.index = 0
        this.timer = null
        this.paused = false
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
        this.autoplay = this.dataset.autoplay === 'true' && !this.reducedMotion
        this.interval = Math.max(3000, Number(this.dataset.interval) || 4000)
        if (!this.viewport || !this.track || this.items.length < 2) return

        this.addEventListener('pointerenter', () => { this.paused = true; this.stop() })
        this.addEventListener('pointerleave', () => { this.paused = false; this.schedule() })
        this.addEventListener('focusin', () => { this.paused = true; this.stop() })
        this.addEventListener('focusout', () => { window.setTimeout(() => { this.paused = this.contains(document.activeElement); this.schedule() }, 0) })
        this.viewport.addEventListener('pointerdown', () => { this.paused = true; this.stop() })
        this.viewport.addEventListener('pointerup', () => { this.paused = false; this.syncIndex(); this.schedule() })
        this.viewport.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') { event.preventDefault(); this.move(1) }
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.move(-1) }
        })
        document.addEventListener('visibilitychange', () => document.hidden ? this.stop() : this.schedule())
        this.schedule()
      }

      stop() { window.clearTimeout(this.timer); this.timer = null }
      schedule() {
        this.stop()
        if (!this.autoplay || this.paused || document.hidden) return
        this.timer = window.setTimeout(() => this.move(1), this.interval)
      }
      syncIndex() {
        const left = this.viewport.scrollLeft
        let nearest = 0
        let distance = Number.POSITIVE_INFINITY
        this.items.forEach((item, i) => {
          const d = Math.abs(item.offsetLeft - left)
          if (d < distance) { distance = d; nearest = i }
        })
        this.index = nearest
      }
      move(direction) {
        this.stop()
        this.syncIndex()
        this.index += direction
        if (this.index >= this.items.length) this.index = 0
        if (this.index < 0) this.index = this.items.length - 1
        const target = this.items[this.index]
        if (!target) return
        this.viewport.scrollTo({ left: target.offsetLeft, behavior: this.reducedMotion ? 'auto' : 'smooth' })
        window.setTimeout(() => this.schedule(), this.reducedMotion ? 50 : 650)
      }
    }
    customElements.define('cf-mini-product-carousel', CFMiniProductCarousel)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
